<article [class.pagebreakbefore]="wantsPageBreak">
  @if (gateways) {
    <section>
      <main class="header">
        <div>
          <div>
            <h3>{{ insight.types[type].title }}</h3>
          </div>

          <div class="alarms">
            @for (alarm of alarmBlocks; track $index) {
              <div class="alarm">
                <div><span class="mdi mdi-circle {{ alarm.colour }}"></span> {{ alarm.header }}</div>
                <div>{{ alarm.title }}</div>
              </div>
            }
          </div>
        </div>
        <div>
          <div>
            <img src="{{ svgLocation }}icon-{{ type }}.svg" />
          </div>
          <div class="average">
            {{ data?.monthTotals.grandtotal.avg }}<small>{{ insight.types[type].measurement }}</small>
          </div>
        </div>
      </main>
      <div class="mt-1">
        {{ insight.types[type].description }}
      </div>

      <div class="gateways mt-1">
        @if (data?.telemetry) {
          <div class="chart">
            <app-d3-chart [hasToClickToInteract]="true" [canAnnotate]="false" [canZoom]="false" [height]="200" [telemetry]="data.telemetry" [limitLines]="limitLines" [showLegend]="true" [minMaxFromData]="true"> </app-d3-chart>
          </div>
        }
        <table class="table">
          <thead>
            <tr>
              <td></td>
              <td>Gateway</td>
              <td>Average</td>
              <td>Lowest</td>
              <td>Highest</td>
            </tr>
          </thead>
          <tbody>
            @for (gatewayData of gateways; track gatewayData) {
              <tr>
                <td><img src="{{ svgLocation }}icon-{{ type }}.svg" /></td>
                <td>{{ gatewayData.gateway.title }}</td>
                @if (gatewayData.totals?.colours) {
                  <td>
                    <span class="mdi mdi-checkbox-blank-circle {{ gatewayData.totals?.colours.avg }}"></span> {{ gatewayData.totals?.avg }}<small>{{ insight.types[type].measurement }}</small>
                  </td>
                }
                @if (gatewayData.totals?.colours) {
                  <td>
                    <span class="mdi mdi-checkbox-blank-circle {{ gatewayData.totals?.colours.min }}"></span> {{ gatewayData.totals?.min }}<small>{{ insight.types[type].measurement }}</small>
                  </td>
                }
                @if (gatewayData.totals?.colours) {
                  <td>
                    <span class="mdi mdi-checkbox-blank-circle {{ gatewayData.totals?.colours.max }}"></span> {{ gatewayData.totals?.max }}<small>{{ insight.types[type].measurement }}</small>
                  </td>
                }
                @if (!gatewayData.totals?.colours) {
                  <td colspan="3"></td>
                }
              </tr>
            }
            @for (gatewayData of collections; track gatewayData) {
              <tr>
                <td><img src="{{ svgLocation }}icon-{{ type }}.svg" /></td>
                <td>{{ gatewayData.gateway.title }}</td>
                @if (gatewayData.totals?.colours) {
                  <td>
                    <span class="mdi mdi-checkbox-blank-circle {{ gatewayData.totals?.colours.avg }}"></span> {{ gatewayData.totals?.avg }}<small>{{ insight.types[type].measurement }}</small>
                  </td>
                }
                @if (gatewayData.totals?.colours) {
                  <td>
                    <span class="mdi mdi-checkbox-blank-circle {{ gatewayData.totals?.colours.min }}"></span> {{ gatewayData.totals?.min }}<small>{{ insight.types[type].measurement }}</small>
                  </td>
                }
                @if (gatewayData.totals?.colours) {
                  <td>
                    <span class="mdi mdi-checkbox-blank-circle {{ gatewayData.totals?.colours.max }}"></span> {{ gatewayData.totals?.max }}<small>{{ insight.types[type].measurement }}</small>
                  </td>
                }
                @if (!gatewayData.totals?.colours) {
                  <td colspan="3"></td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
  }
</article>
